const TextTransformDatabaseEnum = (text) => {
  const textList = {
    // Product Categories // Righ side value is based on database enum weneed to tranform before sending to API
    'main dish': 'main_dish', // Righ side value is based on database enum
    'power side': 'power_side', // Righ side value is based on database enum
    'drink or dessert or treat': 'drink_dessert_treat', // Righ side value is based on database enum
    'main course': 'main_course',
  };

  return textList[text] || text;
};

export default TextTransformDatabaseEnum;
